import { Controller } from 'stimulus';

export default class extends Controller {
  #selected = new Map();
  #onAddition = null;
  #onRemoval = null;
  #onCancel = null;
  static values = { identifier: String };
  static targets = ['counter', 'actions'];

  connect() {
    this.#onAddition = this.#add.bind(this);
    this.#onRemoval = this.#remove.bind(this);
    this.#onCancel = this.cancelSelection.bind(this);

    this.element.addEventListener('cancel', this.#onCancel);
    document.addEventListener(this.#eventFor('add'), this.#onAddition);
    document.addEventListener(this.#eventFor('remove'), this.#onRemoval);
  }

  disconnect() {
    this.element.removeEventListener('cancel', this.#onCancel);
    document.removeEventListener(this.#eventFor('add'), this.#onAddition);
    document.removeEventListener(this.#eventFor('remove'), this.#onRemoval);
  }

  cancelSelection() {
    this.#selected.forEach((selected) => (selected.element.checked = false));
    this.#selected.clear();
    this.counterTarget.dataset.count = 0;
    this.#hideActionBar(true);
  }

  #add(event) {
    const elementKey = JSON.stringify(event.detail.element);
    this.#selected.set(elementKey, event.detail.element);
    this.#syncStatus();
  }

  #remove(event) {
    const elementKey = JSON.stringify(event.detail.element);
    this.#selected.delete(elementKey);
    this.#syncStatus();
  }

  #syncStatus() {
    const selectedCount = this.#selected.size;
    this.actionsTargets.map(this.#updateActionsData.bind(this));
    this.counterTarget.innerHTML = `${selectedCount} selected`;
    this.counterTarget.dataset.count = selectedCount;
    this.#hideActionBar(selectedCount === 0);
  }

  #differentFrom(element) {
    // FIXME: [folders] Consider alternatives for JSON.stringify
    return (el) => JSON.stringify(el) !== JSON.stringify(element);
  }

  #hideActionBar(hide) {
    this.element.classList.toggle('fade-in-up', !hide);
  }

  #eventFor(action) {
    return `batch-actions:${this.identifierValue}:${action}`;
  }

  #updateActionsData(target) {
    const eventData = { detail: { selected: this.#selected.values() }, target };
    this.dispatch('update', eventData);
  }
}
